var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.show)?_c('v-alert',{attrs:{"type":"warning"}},[_vm._v(" Cancelou com Sucesso a subscrição do newsletter. Você não receberá mais notificações sobre as newsletters do gugla. ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }